import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import withErrorBoundaryReturnNull from '../../../../../components/hocs/withErrorBoundaryReturnNull'
import taskLinks from '../../../../../utils/routing/taskLinks'

class TaskItem extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  }

  render() {
    const { data } = this.props
    return (
      <li className="list-group-item">
        <Link to={taskLinks.mapTaskTypeToLink(data.type)}>
          <h6>
            <strong>{data.name}</strong>
            <span className={`pull-right ${data.completed ? 'text-success' : 'text-danger'}`}>
              {data.completed ? 'Complete' : 'Incomplete'}
            </span>
          </h6>
        </Link>
        <p>{data.description || data.content}</p>
        {!data.completed &&
          (<p className="text-muted" style={{fontSize: 12}}>Due {moment(data.dueDate).fromNow()}</p>)
        }
        {/*By {accountUtils.getFullName(data.assignedBy)}*/}
      </li>
    )
  }
}

export default withErrorBoundaryReturnNull(TaskItem)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Dashboard/components/Tasks/TaskItem.js